import { cn } from "@/lib/utils";

interface WaveDividerProps {
  /** Color of the section above (CSS color string) */
  topColor: string;
  /** Color of the section below (CSS color string) */
  bottomColor: string;
  /** Visual variant for variety between sections */
  variant?: "wave1" | "wave2" | "wave3";
  /** Flip the wave vertically */
  flip?: boolean;
  className?: string;
}

export function WaveDivider({
  topColor,
  bottomColor,
  variant = "wave1",
  flip = false,
  className,
}: WaveDividerProps) {
  const paths: Record<string, string> = {
    wave1: "M0,64 C320,120 480,0 720,48 C960,96 1200,16 1440,64 L1440,128 L0,128 Z",
    wave2: "M0,80 C240,20 480,100 720,60 C960,20 1200,90 1440,50 L1440,128 L0,128 Z",
    wave3: "M0,48 C180,100 360,30 540,70 C720,110 900,20 1080,60 C1260,100 1380,40 1440,56 L1440,128 L0,128 Z",
  };

  return (
    <div
      className={cn(
        "relative w-full pointer-events-none select-none -mb-px",
        flip && "rotate-180",
        className
      )}
      style={{ backgroundColor: topColor }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 128"
        preserveAspectRatio="none"
        className="block w-full h-16 md:h-20 lg:h-24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={paths[variant]} fill={bottomColor} />
      </svg>
    </div>
  );
}
